import { SetStateAction, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useUserInfor } from "../../../../../../Context/User";
import {
    ListarIndexadoresSiengeController,
    ListarPortadoresSiengeController,
    ListarTiposCondicaoPagamentoSiengeController,
} from "../../../../../../Controllers/Cobranca/RenegociacaoSienge/RenegociacaoSiengeController";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import { IParcelaBoletosResponseSienge } from "../../../../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import { formatMoneyReais } from "../../../../../../Tools/FormatTools";
import { MoneyReaisFieldMask } from "../../../../../../Validations/InputMasks";
import { useRegistrarAcordoSiengeContext } from "../..";
import moment from "moment";
import {
    IListIndexadoresSienge,
    IListTipoCondicoesPagamentoSienge,
} from "../../../../../../Interfaces/Cobranca/RenegociacaoSienge/RenegociacaoSiengeInterface";
import { Spinner } from "../../../../../../Components/Loding/SpinnerPadrao";

interface IEditarAdicionarCondicoesPagamento {
    setShow: (value: SetStateAction<boolean>) => void;
    row?: IParcelaBoletosResponseSienge;
}
export default function EditarAdicionarCondicoesPagamento(
    props: IEditarAdicionarCondicoesPagamento
) {
    const FormMethods = useForm();

    const { register, handleSubmit, watch, formState, setValue } = FormMethods;

    const [descricaoParValue, setDescricaoParValue] = useState(
        props.row?.Descricao_par
    );

    const [objectSelectDescricaoPar, setObjectSelectDescricaoPar] =
        useState<IListTipoCondicoesPagamentoSienge>();

    const [objectSelectIndexador, setObjectSelectIndexador] =
        useState<IListIndexadoresSienge>();

    const {
        lstSelecionadosParcelasGeradas,
        setLstSelecionadosParcelasGeradas,
    } = useRegistrarAcordoSiengeContext();

    const { value: lstTipoCondicoes, loading: lstTipoCondicoesLoading } =
        useAsyncEffect(() => ListarTiposCondicaoPagamentoSiengeController(""));

    const { value: lstPortadores, loading: lstPortadoresLoading } =
        useAsyncEffect(() => ListarPortadoresSiengeController());

    const { value: lstIndexadores, loading: lstIndexadoresLoading } =
        useAsyncEffect(() => ListarIndexadoresSiengeController());

    const planaltoMode = "6C8F630D-8BB9-4934-9110-423438BDBF8A";

    const { OrgInfor } = useUserInfor();

    function handleSubmitEditCadastro(formData: IParcelaBoletosResponseSienge) {
        formData.Descricao_par = descricaoParValue || watch("Descricao_par");

        formData.NumParc_Prc = formData.NumParc_Prc || Date.now();

        formData.idDescricao_par =
            lstTipoCondicoes?.find(
                (lst) => watch("Descricao_par") === lst.description
            )?.id || "";
        formData.idPortadorPrc =
            lstPortadores?.find(
                (lst) => watch("portadorPrc") === lst.bearerName
            )?.bearerId || 0;
        formData.idIndexadorPrc =
            lstIndexadores?.find((lst) => watch("IdxReaj_Prc") === lst.name)
                ?.id || 0;
        formData.tipoJurosPrc = watch("tipoJurosPrc");

        objectSelectIndexador &&
            (formData.DtBase_Correcao = objectSelectIndexador?.lastValue.date);

        return new Promise((resolve, reject) => {
            if (props.row) {
                const index = lstSelecionadosParcelasGeradas?.findIndex(
                    (item) => item.NumParc_Prc === props.row?.NumParc_Prc
                );

                if (index !== -1) {
                    const updatedList = [
                        ...(lstSelecionadosParcelasGeradas || []),
                    ];
                    updatedList[index || 0] = formData;

                    setLstSelecionadosParcelasGeradas(updatedList);

                    resolve(updatedList);
                }
            } else {
                setLstSelecionadosParcelasGeradas((prevState) => [
                    ...(prevState || []),
                    formData,
                ]);

                resolve(lstSelecionadosParcelasGeradas);
            }
        }).then(() => {
            props.setShow(false);
        });
    }

    useEffect(() => {
        if (lstTipoCondicoes && lstTipoCondicoes.length > 0) {
            const selectedObject = lstTipoCondicoes.find(
                (lst) => watch("Descricao_par") === lst.description
            );

            if (selectedObject) {
                setObjectSelectDescricaoPar(selectedObject);
            }
        }

        if (lstIndexadores && lstIndexadores.length > 0) {
            const selectedObject = lstIndexadores.find(
                (lst) => watch("IdxReaj_Prc") === lst.name
            );

            if (selectedObject) {
                setObjectSelectIndexador(selectedObject);
            }
        }
    }, [lstIndexadores, lstTipoCondicoes, watch]);

    return lstTipoCondicoesLoading ||
        lstPortadoresLoading ||
        lstIndexadoresLoading ? (
        <div className="d-flex justify-content-center">
            <Spinner color="primary" size="md" />
        </div>
    ) : (
        <form onSubmit={handleSubmit(handleSubmitEditCadastro)}>
            <div className="mb-5">
                <h3>Informações sobre as condições de pagamento</h3>
                <div className="col-12">
                    <div className="row">
                        <div className="col-md-4">
                            <label>Tipo condição</label>

                            <select
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.Descricao_par &&
                                    "is-invalid"
                                }`}
                                name="Descricao_par"
                                disabled={
                                    OrgInfor.ID_ORGANIZACAO === planaltoMode
                                }
                                ref={register({
                                    required: "Selecione o tipo de condição",
                                })}
                                value={descricaoParValue}
                                onChange={(e) => {
                                    const selectedObject =
                                        lstTipoCondicoes?.find(
                                            (tipo) =>
                                                tipo.description ===
                                                e.target.value
                                        );
                                    setDescricaoParValue(e.target.value);
                                    setObjectSelectDescricaoPar(selectedObject);
                                }}
                            >
                                <option></option>
                                {lstTipoCondicoes?.map((tipos) => (
                                    <option
                                        key={tipos.id}
                                        value={tipos.description}
                                        selected={
                                            OrgInfor.ID_ORGANIZACAO ===
                                                planaltoMode &&
                                            !props.row &&
                                            "RC" === tipos.id
                                        }
                                    >
                                        {tipos.id} / {tipos.description}
                                    </option>
                                ))}
                            </select>
                            {formState.errors.Descricao_par && (
                                <p className="text-danger">
                                    {formState.errors.Descricao_par.message}
                                </p>
                            )}
                        </div>

                        <div className="col-md-4">
                            <label>Valor total</label>
                            <input
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.ValorReaj && "is-invalid"
                                }`}
                                name="ValorReaj"
                                defaultValue={
                                    props.row?.ValorReaj
                                        ? formatMoneyReais(props.row?.ValorReaj)
                                        : undefined
                                }
                                ref={register({
                                    setValueAs: (v) =>
                                        Number(MoneyReaisFieldMask.unMask(v)),
                                    required: "Informe o valor total",
                                })}
                                onChange={(e) => {
                                    MoneyReaisFieldMask(e);
                                }}
                            />
                            {formState.errors.ValorReaj && (
                                <p className="text-danger">
                                    {formState.errors.ValorReaj.message}
                                </p>
                            )}
                        </div>
                        <div className="col-md-4">
                            <label>Portador</label>
                            <select
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.portadorPrc && "is-invalid"
                                }`}
                                name="portadorPrc"
                                ref={register({
                                    required: "Selecione o portador",
                                })}
                            >
                                <option></option>
                                {lstPortadores?.map((tipos) => (
                                    <option
                                        key={tipos.bearerId}
                                        selected={
                                            OrgInfor.ID_ORGANIZACAO ===
                                                planaltoMode &&
                                            props.row &&
                                            props.row?.portadorPrc ===
                                                tipos.bearerName
                                        }
                                    >
                                        {tipos.bearerName}
                                    </option>
                                ))}
                            </select>
                            {formState.errors.portadorPrc && (
                                <p className="text-danger">
                                    {formState.errors.portadorPrc.message}
                                </p>
                            )}
                        </div>

                        <div className="col-md-4">
                            <label>Quantidade</label>
                            <input
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.quantidadePrc &&
                                    "is-invalid"
                                }`}
                                name="quantidadePrc"
                                type="number"
                                defaultValue={props.row?.quantidadePrc}
                                ref={register({
                                    required:
                                        "Informe a quantidade de parcelas",
                                    min: 0,
                                    max: {
                                        value:
                                            objectSelectDescricaoPar?.MaxInstallmentsNumber ||
                                            900,
                                        message:
                                            "O valor máximo permitido é 900",
                                    },
                                    pattern: {
                                        value: /^[0-9]*$/,
                                        message: "Informe um valor válido",
                                    },
                                })}
                                onChange={(e) => {
                                    let value = parseInt(e.target.value);

                                    if (isNaN(value) || value < 0) {
                                        value = 0;
                                    }

                                    if (
                                        value >
                                        (objectSelectDescricaoPar?.MaxInstallmentsNumber ||
                                            900)
                                    ) {
                                        value =
                                            objectSelectDescricaoPar?.MaxInstallmentsNumber ||
                                            900;
                                    }

                                    setValue("quantidadePrc", value);
                                }}
                            />
                            {formState.errors.quantidadePrc && (
                                <p className="text-danger">
                                    {formState.errors.quantidadePrc.message}
                                </p>
                            )}
                        </div>

                        <div className="col-md-4">
                            <label>Data do 1º Vencimento</label>
                            <input
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.Data_Prc && "is-invalid"
                                }`}
                                name="Data_Prc"
                                type="date"
                                defaultValue={
                                    props.row?.Data_Prc
                                        ? moment(props.row?.Data_Prc).format(
                                              "YYYY-MM-DD"
                                          )
                                        : ""
                                }
                                ref={register({
                                    required: "Informe a data do 1º vencimento",
                                })}
                            />
                            {formState.errors.Data_Prc && (
                                <p className="text-danger">
                                    {formState.errors.Data_Prc.message}
                                </p>
                            )}
                        </div>
                        <div className="col-md-4">
                            <div className="d-flex flex-column justify-content-center">
                                <label className="text-center">
                                    Vencimentos podem coincidir com outras
                                    parcelas
                                </label>
                                <span
                                    className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center"
                                    data-toggle="tooltip"
                                >
                                    <label>
                                        <input
                                            id="operacaoCobrancaPrc"
                                            name="operacaoCobrancaPrc"
                                            defaultChecked={
                                                props.row?.operacaoCobrancaPrc
                                            }
                                            type="checkbox"
                                        />
                                        <span></span>
                                    </label>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mb-5">
                <h3>Informações para correção das parcelas</h3>
                <div className="col-12">
                    <div className="row">
                        <div className="col-md-4">
                            <label>Indexador</label>
                            <select
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.IdxReaj_Prc && "is-invalid"
                                }`}
                                name="IdxReaj_Prc"
                                ref={register({
                                    required: "Selecione o indexador",
                                })}
                            >
                                <option></option>
                                {lstIndexadores?.map((tipos) => (
                                    <option
                                        key={tipos.id}
                                        value={tipos.name}
                                        selected={
                                            props.row?.IdxReaj_Prc ===
                                            tipos.name
                                        }
                                    >
                                        {tipos.name}
                                    </option>
                                ))}
                            </select>
                            {formState.errors.IdxReaj_Prc && (
                                <p className="text-danger">
                                    {formState.errors.IdxReaj_Prc.message}
                                </p>
                            )}
                        </div>

                        <div className="col-md-4">
                            <label>Data base</label>
                            <input
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.DtBase_Correcao &&
                                    "is-invalid"
                                }`}
                                name="DtBase_Correcao"
                                type="date"
                                defaultValue={
                                    objectSelectIndexador
                                        ? moment(
                                              objectSelectIndexador.lastValue
                                                  .date
                                          ).format("YYYY-MM-DD")
                                        : ""
                                }
                                disabled={!!lstIndexadores}
                                ref={register()}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="mb-5">
                <h3>Informações para juros contratuais</h3>
                <div className="col-12">
                    <div className="row">
                        <div className="col-md-4">
                            <label>Tipo Juros</label>
                            <select
                                className={`form-control placeholder-dark-75 ${
                                    formState.errors.tipoJurosPrc &&
                                    "is-invalid"
                                }`}
                                name="tipoJurosPrc"
                                ref={register({
                                    required: "Selecione o tipo de juros",
                                })}
                                defaultValue={props.row?.tipoJurosPrc}
                            >
                                <option value=""></option>
                                <option value="N">Nenhum</option>
                                <option value="P">Price</option>
                                <option value="A">S.A.C</option>
                                <option value="S">Simples</option>
                                <option value="C">Composto</option>
                                <option value="F">Fixo</option>
                            </select>
                            {formState.errors.tipoJurosPrc && (
                                <p className="text-danger">
                                    {formState.errors.tipoJurosPrc.message}
                                </p>
                            )}
                        </div>

                        <div className="col-md-4">
                            <label>Percentual ao período</label>
                            <input
                                className="form-control"
                                name="percentualAoPeriodoPrc"
                                type="number"
                                ref={register()}
                                disabled={watch("tipoJurosPrc") === "N"}
                                defaultValue={props.row?.percentualAoPeriodoPrc}
                            />
                        </div>

                        <div className="col-md-4">
                            <label>Carência</label>
                            <input
                                className="form-control"
                                name="carenciaPrc"
                                type="number"
                                ref={register()}
                                disabled={watch("tipoJurosPrc") === "N"}
                                defaultValue={props.row?.carenciaPrc}
                            />
                        </div>

                        <div className="col-md-4">
                            <label>Data base para juros</label>
                            <input
                                className="form-control"
                                name="dataBaseParaJurosPrc"
                                type="date"
                                ref={register()}
                                disabled={watch("tipoJurosPrc") === "N"}
                                defaultValue={
                                    props.row?.dataBaseParaJurosPrc
                                        ? moment(
                                              props.row?.dataBaseParaJurosPrc
                                          ).format("YYYY-MM-DD")
                                        : ""
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end">
                <button
                    className="btn btn-outline-danger mr-3"
                    onClick={() => {
                        props.setShow(false);
                    }}
                >
                    Cancelar
                </button>
                <button
                    type="submit"
                    className={`btn  ${
                        props.row ? "btn-primary" : "btn-success"
                    }`}
                    onClick={() => {}}
                >
                    {props.row ? "Editar" : "Incluir"}
                </button>
            </div>
        </form>
    );
}
